import React, { Component } from 'react';
import { SimpleFetch, SimpleFetchResponse } from '../../../_helpers';

class Images extends Component {
  constructor(props) {
    super(props);

    this.imageContainer = React.createRef();
    this.handleRemoval = this.handleRemoval.bind(this);
  }

  async handleRemoval(e) {
    let imageId = e.target.getAttribute('data-image-id');
    let imgContainer = this.imageContainer.current;

    let req = await SimpleFetch('DELETE', {}, '', 'momentum', `gallery/remove/${imageId}/filename`);
    let res = await SimpleFetchResponse(req, 'Ocorreu um erro ao remover sua mídia.', 'Mídia removida com sucesso!');

    if ( res ) return imgContainer.parentNode.removeChild(imgContainer);
  }

  render() {
    return (
      <div className="image" ref={this.imageContainer}>
        <img src={this.props.image.replace('%252F', '/')} alt={this.props.baseUrl}/>
        
        <div className="card-image-options">
          <button type="button" className="remove" data-image-id={this.props.id} data-image-base-url={this.props.baseUrl} onClick={this.handleRemoval}>
            <i className="linearicons-trash2"></i>
          </button>
        </div>
      </div>
    )
  }
}

export default Images;